// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FhqDesignToolStatusActions{padding:12px}", "",{"version":3,"sources":["webpack://./src/main/js/modules/fhq-design-tool/components/questionnaire-management/components/status-actions/status-actions.styles.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA","sourcesContent":[".FhqDesignToolStatusActions {\n  padding: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
